import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import { type License } from 'src/shared/features/users/schemas/licenses'

const getPublicLicenses = async (userId: number) => {
  try {
    const response = await getRequest<License[]>(`/users/licenses?user_id=${userId}`)
    if (!response) {
      return null
    }
    return response
  } catch (error) {
    console.error('Error fetching public licenses:', error)
    return null
  }
}

export const usePublicLicenses = (userId: number) => {
  return useSuspenseQuery({
    ...queries.users.detailById(userId)._ctx.licenses,
    queryFn: () => (userId < 0 ? null : getPublicLicenses(userId)),
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export const usePublicLicensesQuery = (userId: number) => {
  return useQuery({
    ...queries.users.detailById(userId)._ctx.licenses,
    queryFn: () => (userId < 0 ? null : getPublicLicenses(userId)),
    staleTime: 5 * 60 * 1000,
    enabled: userId > -1,
  })
}
